import { apiGet } from '@/store/api';
import { useAttendanceStore } from '@/store/attendanceStore';

export async function getAttendanceCodes() {
  const data = await apiGet('/attendance/codes');
  useAttendanceStore().setAttendanceCodes(data);
  return data;
}
